/**
 * The thirteen Varzishmate club console screens, and the words that go with them.
 *
 * Generated from store-assets/shots.mjs — the same array compose.mjs burns into
 * the store listing images and copy.mjs turns into COPY.md. The site, the store
 * screenshots and the listing document therefore cannot disagree about what a
 * screen is called or what it claims.
 *
 * Regenerate with: node web/scripts/gen-shots.mjs
 *
 * Every slug has four files under /shots/: {slug}-{light,dark}.{webp,png},
 * the raw captures at 660px wide, downscaled from the 1320x2868 originals the
 * App Store requires.
 */

export const CLUB_SHOTS = [
  {
    slug: "today",
    screen: "Today",
    headline: "Every morning,\nalready sorted.",
    subline: "Who owes, who is expiring, who is waiting — before you open the door.",
    inFrame: "Needs-you-today queue, the month's collected and pending, today's floor count.",
  },
  {
    slug: "members",
    screen: "Members",
    headline: "Your whole roster,\none search away.",
    subline: "Active, owing, expiring, gone quiet — the list already knows.",
    inFrame: "34 members, segment chips with live counts, an outstanding balance on a row.",
  },
  {
    slug: "money",
    screen: "Money",
    headline: "Where the month\nactually went.",
    subline: "Collected against pending, by plan and by method. Export a date range.",
    inFrame: "Collected total, method split, the ledger.",
  },
  {
    slug: "checkin",
    screen: "Check-in",
    headline: "Mark the floor\nas it fills.",
    subline: "Members scan your QR, or you tap a name. Every check-in lands on that member's record.",
    inFrame: "Today's list, partly checked in.",
  },
  {
    // TODO reshoot after auto reminders ship (screenshot and caption still show the old Ask-me-only screen)
    slug: "reminders",
    screen: "Reminders & automations",
    headline: "Chase dues without\nchasing anyone.",
    subline: "Overdue and expiry reminders draft themselves. You read them and send.",
    inFrame: "Rule toggles per stage, channel and send time, the message preview.",
  },
  {
    slug: "staff",
    screen: "Staff",
    headline: "Give a trainer the floor,\nnot the books.",
    subline: "Trainers get members, workouts and check-in. Money stays yours.",
    inFrame: "Roster with role badges and an invited trainer.",
  },
  {
    slug: "plans",
    screen: "Plans & pricing",
    headline: "Your pricing,\nin one place.",
    subline: "Monthly to annual, with the discounts you actually give.",
    inFrame: "Five plans with durations and amounts.",
  },
  {
    slug: "batches",
    screen: "Batches & timings",
    headline: "Morning, evening,\nand who runs them.",
    subline: "Days, times, capacity and the trainer on the floor.",
    inFrame: "Four batches across the week.",
  },
  {
    slug: "templates",
    screen: "Workout templates",
    headline: "Build a plan once,\nassign it forever.",
    subline: "Routines you write are the routines your members get.",
    inFrame: "Saved templates with how many members are on each.",
  },
  {
    slug: "exercises",
    screen: "Exercise library",
    headline: "The library,\nplus whatever you add.",
    subline: "Every movement, with the muscles it works and how it is done.",
    inFrame: "Exercise library with the club's own additions.",
  },
  {
    slug: "club",
    screen: "Club hub",
    headline: "Plans, batches, timings —\nset once.",
    subline: "The parts that rarely change, kept out of the way of the parts that do.",
    inFrame: "Set-up groups with live counts.",
  },
  {
    slug: "members-add",
    screen: "Add member",
    headline: "A new member,\nin three steps.",
    subline: "Name, dates and fee, first payment. A plan is optional. Nothing you have to come back and finish.",
    inFrame: "Step 1 of 3.",
  },
  {
    slug: "profile",
    screen: "Club profile",
    headline: "Your club,\nas members see it.",
    subline: "Name, address, hours and the photographs on your listing.",
    inFrame: "Club profile form with the gallery.",
  },
];

/** Where a screen's image lives. `appearance` is 'light' or 'dark'. */
export function shotSrc(slug, appearance, ext = 'webp') {
  return '/shots/' + slug + '-' + appearance + '.' + ext;
}

/** Look one up by slug. */
export function shot(slug) {
  return CLUB_SHOTS.find((s) => s.slug === slug);
}

/** The six that carry the scroll-driven showcase, in order. */
export const FEATURED = ['today', 'members', 'money', 'checkin', 'reminders', 'staff'];

/** The seven that fill the grid below it. */
export const SECONDARY = ['plans', 'batches', 'templates', 'exercises', 'club', 'members-add', 'profile'];
